import homeHeroImage from '../assets/images/home/hero/hero.webp'
import aboutHeroImage from '../assets/images/about/hero/abhero.jpg'
import servicesHeroImage from '../assets/images/services/hero/serhero.jpg'
import contactHeroImage from '../assets/images/contact/contactHero.jpg'
import collaborationsHeroImage from '../assets/images/collaborations/hero.jpg'
import projectsHeroImage from '../assets/images/projects/projhero.jpg'

/** Add new hero imports here and map them to their route. */
export const HERO_IMAGES_BY_ROUTE = {
  '/': [homeHeroImage],
  '/about': [aboutHeroImage],
  '/service': [servicesHeroImage],
  '/contact': [contactHeroImage],
  '/collaborations': [collaborationsHeroImage],
  '/projects': [projectsHeroImage],
}

export const ALL_HERO_IMAGES = [
  ...new Set(Object.values(HERO_IMAGES_BY_ROUTE).flat()),
]

export const getHeroImagesForPath = (pathname) =>
  HERO_IMAGES_BY_ROUTE[pathname] ?? []
